import React from "react";
import { Play } from "lucide-react";
import { t } from "../../lib/i18n";

/**
 * Under the name of the player who chose "Continuer" at the redeal vote
 * (game.redeal_continuer_id): « شدّ الفريش » / « A gardé la donne » / « Kept the deal ».
 * Rose while that player has not posed yet (the continuer penalty still threatens),
 * emerald once they have. Shown on the opponents only: the player who chose it does not see it on their own badge.
 */
export function ContinuerTag({ posed = false, className = "" }) {
  const tone = posed
    ? "bg-emerald-400/[0.12] text-emerald-200 ring-emerald-300/30"
    : "bg-rose-400/[0.12] text-rose-200 ring-rose-300/30";
  return (
    <span
      title={t("opp.continuerTitle")}
      data-testid="continuer-tag"
      className={`inline-flex items-center gap-[3px] h-[14px] shrink-0 rounded-full ps-[3px] pe-1.5 ring-1 ring-inset text-[8.5px] font-semibold leading-none whitespace-nowrap tracking-[0.01em] ${tone} ${className}`}
    >
      <span className={`flex h-[9px] w-[9px] items-center justify-center rounded-full ${posed ? "bg-emerald-300/90" : "bg-rose-300/90"}`}>
        <Play className="h-[5px] w-[5px] translate-x-[0.5px] fill-slate-950 text-slate-950" strokeWidth={3} />
      </span>
      {t("opp.continuer")}
    </span>
  );
}

export default ContinuerTag;
